var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftBlueArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2091 8.20135L6.63863 8.20134L11.793 3.04698C12.491 2.349 12.491 1.22148 11.793 0.523492C11.095 -0.174495 9.96749 -0.174495 9.26951 0.523491L1.05474 8.73826C0.356752 9.43624 0.356752 10.5638 1.05474 11.2617L9.2695 19.4765C9.96749 20.1745 11.095 20.1745 11.793 19.4765C12.491 18.7785 12.491 17.651 11.793 16.953L6.63863 11.7808L30.2091 11.7808C31.1934 11.7808 31.9988 10.9754 31.9988 9.99106C31.9988 9.00672 31.1934 8.20135 30.2091 8.20135Z",
    fill: "#2B4E7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlueArrow);
export default __webpack_public_path__ + "static/media/leftBlueArrow.803f278cb4e9a620ac137d4c62aa3b1b.svg";
export { ForwardRef as ReactComponent };